<template> 
  <nav>
    <template    >
      <component  :is="headerComponent"/>
    </template>
  </nav>  
  <component  >
    <router-view/>
  </component>
    <component   :is="footerComponent" />
  
  
</template>
<style>
th{
  background: #00007c !important;
  color: white !important;
  padding: 8px 5px !important;
}
@media (max-width:600px)  { 
 #topline-tab{
  DISPLAY: flex;
    overflow-x: scroll;
    overflow-y: hidden;
 }
}
.form-control{
    padding: 0.25rem 0.25rem;
}
body,button, input, optgroup, select, textarea {
    font-family: sans-serif;
 
}
.form-control:focus{
    box-shadow: 0 0 0 0.02rem rgb(0 103 255);
}
:root{
    --theme-deafult:#003171;
}
table.dataTable  .badge {
    line-height: 10px !important;
}
template{
    display: block!important;
}
</style>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue';
import FooterPart from '@/components/Footer.vue'; 
import ModalsPart from '@/components/Modals.vue';

export default {
  
  name: 'App',
   
  data() {
    return { 
        header_part: Header,
        footer_part: FooterPart,
       
    };
  },
  computed: {
    // headerComponent() {
    //   return (!['vr','ap','vp','vehiclepassview','visitorgatepassview','employeegatepassview','printpass','login','visitorpage','capture','register','visitorprofile','visitorcreategatepass','approvegatepass','qrcodereader','/'].includes(this.$route.name))&&(this.$route.name)?this.header_part : null;
    // },
    
   
    // footerComponent() {
    //   return (!['vr','ap','vp','vehiclepassview','visitorgatepassview','employeegatepassview','printpass','login','visitorpage','capture','register','visitorprofile','visitorcreategatepass','approvegatepass','qrcodereader','/'].includes(this.$route.name))&&(this.$route.name)?this.footer_part : null;
    // },
    
    headerComponent() {
        
          const excluded = ['ProfilePage','PastPage','ActivePage','vr','ap','vp','vehiclepassview','visitorgatepassview','employeegatepassview','printpass','login','visitorpage','capture','register','visitorprofile','visitorcreategatepass','approvegatepass','qrcodereader','undefined'];
          return (this.$route.name=='' || !excluded.includes(this.$route.name)) ? this.header_part : null;
        },
        footerComponent() {
          const excluded = ['ProfilePage','PastPage','ActivePage','vr','ap','vp','vehiclepassview','visitorgatepassview','employeegatepassview','printpass','login','visitorpage','capture','register','visitorprofile','visitorcreategatepass','approvegatepass','qrcodereader','undefined'];
          return (this.$route.name=='' || !excluded.includes(this.$route.name)) ? this.footer_part : null;
        }
  },
}

</script>